/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Google_Unlink_DoneInputs */

const cs_settings_google_unlink_done = /** @type {(inputs: Settings_Google_Unlink_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google účet odpojen`)
};

const en_settings_google_unlink_done = /** @type {(inputs: Settings_Google_Unlink_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google account unlinked`)
};

/**
* | output |
* | --- |
* | "Google account unlinked" |
*
* @param {Settings_Google_Unlink_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_google_unlink_done = /** @type {((inputs?: Settings_Google_Unlink_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Google_Unlink_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_google_unlink_done(inputs)
	return cs_settings_google_unlink_done(inputs)
});